import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=0d83ac28&"
import script from "./noticeDetail.vue?vue&type=script&lang=js&"
export * from "./noticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=0d83ac28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports